import React, { useState, useEffect } from 'react';
import {
  Platform,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  View,
  TouchableOpacity,
  ImageBackground
} from "react-native";

import { COLORS, SIZES, IMAGES, FONTS } from '../constants';
import { useNavigation } from '@react-navigation/native';
import { MaterialIcons } from '@expo/vector-icons';

import AsyncStorage from '@react-native-async-storage/async-storage';

export default function FinalTestScreen() {

  const navigation = useNavigation();

  const [isLoading, setIsLoading] = useState(true);
  const [ageGroup, setAgeGroup] = useState("");
  const [sex, setSex] = useState("");
  const [category, setCategory] = useState("");
  const [selectedPosition, setSelectedPosition] = useState(0);

  const disciplinesData = require('../../assets/json/dyscypliny.json')

  const [competition1, setCompetition1] = useState();
  const [competition2, setCompetition2] = useState();
  const [competition3, setCompetition3] = useState();
  const [competition4, setCompetition4] = useState(disciplinesData[6].shortName);

  const [disciplinesInfo, setDisciplinesInfo] = useState();

  const [d1Value, setD1Value] = useState("");
  const [d2Value, setD2Value] = useState();
  const [d3Value, setD3Value] = useState();
  const [d4Value, setD4Value] = useState();

  const onCheckD1Limit = (value) => {

    if (competition1 === "Bieg") {
      const valueWithDecimal = (value.toString()).replace(",", ".")
      // const parsedQty = Number.parseFloat(value)

      // console.log(valueWithDecimal, parsedQty)

      if (Number.isNaN(valueWithDecimal)) {
        setD1Value(0)
      }  else {
        setD1Value(valueWithDecimal)
      }
      // else if (parsedQty > 26.0) {
      //   setD1Value(26.0)
      // } else {
      //   setD1Value(parsedQty)
      // }

    } else if (competition1 === "Pływanie") {
      const parsedQty = Number.parseInt(value)

      if (Number.isNaN(parsedQty)) {
        setD1Value(0)
      } else if (parsedQty > 650) {
        setD1Value(650)
      } else {
        setD1Value(parsedQty)
      }
    }
  }

  const onCheckD2Limit = (value) => {
    const parsedQty = Number.parseInt(value)

    if (competition2 === "Podciąganie") {
      if (Number.isNaN(parsedQty)) {
        setD2Value(0)
      } else if (parsedQty > 18) {
        setD2Value(18)
      } else {
        setD2Value(parsedQty)
      }

    } else if (competition2 === "Pompki") {
      if (Number.isNaN(parsedQty)) {
        setD2Value(0)
      } else if (parsedQty > 74) {
        setD2Value(74)
      } else {
        setD2Value(parsedQty)
      }
    }
  }

  const onCheckD3Limit = (value) => {
    let valueWithDecimal = ((value).toString()).replace(",", ".")

    if (competition3 === "10x10") {
      if (Number.isNaN(valueWithDecimal)) {
        setD3Value(0)
      } else {
        setD3Value(valueWithDecimal)
      }

    } else if (competition3 === "Koperta") {
      if (Number.isNaN(valueWithDecimal)) {
        setD3Value(0)
      } else {
        setD3Value(valueWithDecimal)
      }
    }
  }

  const onCheckD4Limit = (value) => {
    const parsedQty = Number.parseInt(value)
    if (Number.isNaN(parsedQty)) {
      setD4Value(0)
    } else if (parsedQty > 80) {
      setD4Value(80)
    } else {
      setD4Value(parsedQty)
    }
  }

  const getData = async () => {
    try {
      // const jsonValue = await AsyncStorage.getItem('@disciplines')

      const jsonValue = await AsyncStorage.multiGet(['@disciplines', '@profile']).then(response => {
        // console.log((JSON.parse(response[1][1])).group)
        setDisciplinesInfo(JSON.parse(response[0][1]));

        disciplinesData.forEach((disc) => {
          if (disc.name === (JSON.parse(response[0][1])).d1) {
            setCompetition1(disc.shortName);
          } else if (disc.name === (JSON.parse(response[0][1])).d2) {
            setCompetition2(disc.shortName);
          } else if (disc.name === (JSON.parse(response[0][1])).d3) {
            setCompetition3(disc.shortName);
          } else if (disc.name === (JSON.parse(response[0][1])).d4) {
            setCompetition4(disc.shortName);
          }
        })

        setAgeGroup((JSON.parse(response[1][1])).group);
        setSex((JSON.parse(response[1][1])).sex);
        setCategory((JSON.parse(response[1][1])).cat);
        setSelectedPosition((JSON.parse(response[1][1])).column);

      })

    } catch (e) {
      console.log("error", e)
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) {
    return (
      <ImageBackground
        source={IMAGES.bg2}
        style={styles.bg}
      >
        <View style={styles.container}>
          <Text style={styles.titleText}>Pobieram dane...</Text>
        </View>
      </ImageBackground>
    );
  }

  return (

    <ImageBackground
      source={IMAGES.bg2}
      style={styles.bg}
    >

      <View style={styles.container}>
        <View style={styles.inputRow}>
          <View style={styles.box}>
            <Text style={styles.label}>
              {competition1}
            </Text>
            <TextInput
              value={d1Value !== 0 ? d1Value : ""}
              maxLength={competition1 === "Bieg" ? 5 : 3}
              placeholder={competition1 === "Bieg" ? "mm.ss" : "metry"}
              placeholderTextColor={COLORS.secondary}
              keyboardType={competition1 === "Bieg" ? "decimal-pad" : "numeric"}
              style={styles.input}
              onChangeText={val => {
                onCheckD1Limit(val)
              }}
            />
          </View>

          <View style={styles.box}>
            <Text style={styles.label}>
              {competition2}
            </Text>
            <TextInput
              value={d2Value !== 0 ? d2Value : ""}
              maxLength={2}
              placeholder="ilość"
              placeholderTextColor={COLORS.secondary}
              keyboardType="numeric"
              style={styles.input}
              onChangeText={val => {
                onCheckD2Limit(val)
              }}
            />
          </View>
        </View>
        <View style={styles.inputRow}>
          <View style={styles.box}>
            <Text style={styles.label}>
              {competition3}
            </Text>
            <TextInput
              value={d3Value !== 0 ? d3Value : ""}
              maxLength={5}
              placeholder="mm.ss"
              placeholderTextColor={COLORS.secondary}
              keyboardType="decimal-pad"
              style={styles.input}
              onChangeText={val => {
                onCheckD3Limit(val)
              }}
            />
          </View>

          <View style={styles.box}>
            <Text style={styles.label}>
              {competition4}
            </Text>
            <TextInput
              value={d4Value !== 0 ? d4Value : ""}
              maxLength={2}
              placeholder="ilość"
              placeholderTextColor={COLORS.secondary}
              keyboardType="numeric"
              style={styles.input}
              onChangeText={val => {
                onCheckD4Limit(val)
              }}
            />
          </View>
        </View>


        <TouchableOpacity
          style={styles.button}
          onPress={() => {
            navigation.navigate('FinalTestResult', {
              d1Key: d1Value,
              d1nameKey: competition1,
              d2Key: d2Value,
              d2nameKey: competition2,
              d3Key: d3Value,
              d3nameKey: competition3,
              d4Key: d4Value,
              d4nameKey: competition4,
              ageGroupKey: ageGroup,
              sexKey: sex,
              categoryKey: category,
              selectedPositionKey: selectedPosition
            });
          }}
        >
          <ImageBackground
            source={IMAGES.arrowBtnBg}
            style={styles.arrowBtnBg}
          >
            <View style={styles.arrowBtn}>
              <MaterialIcons name="arrow-forward" size={48} color={COLORS.primary} />
            </View>
          </ImageBackground>
        </TouchableOpacity>


      </View>

    </ImageBackground>
  );
}

// const styles = StyleSheet.create({
//   container: {
//     padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
//     flex: 1,
//     alignItems: 'center', justifyContent: 'center',
//     backgroundColor: COLORS.background,
//     padding: SIZES.padding,
//   }
// })

const styles = StyleSheet.create({
  container: {
    // alignItems: 'center',
    // justifyContent: 'center',
    padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    // backgroundColor: COLORS.background,
    padding: SIZES.padding,
  },
  header: {
    justifyContent: 'flex-start',
  },
  bg: {
    width: "100%",
    height: "100%"
  },
  intro: {
    flexDirection: "row"
  },
  inputRow: {
    flexDirection: "row",
    height: 200,
    marginBottom: 10,
  },
  box: {
    padding: 5,
    margin: 0,
    height: "100%",
    width: "50%",
  },
  label: {
    position: 'absolute',
    top: -2,
    left: 20,
    color: COLORS.primary,
    backgroundColor: COLORS.background,
    fontSize: 14,
  },
  input: {
    borderColor: COLORS.secondary,
    backgroundColor: COLORS.background,
    borderWidth: 1,
    borderRadius: 10,
    textAlign: "center",
    height: "100%",
    width: "100%",
    fontSize: 45,
    color: COLORS.accent
  },
  arrowBtn: {
    width: 80,
    height: 80,
    marginRight: 20,
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.background
  },
  arrowBtnBg: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    position: 'absolute',
    right: 0,
    bottom: 20,
    width: 122,
    height: 100,
    resizeMode: 'cover',
  },
  buttonText: {
    alignSelf: "center",
    padding: 30,
    fontSize: 25,
    color: "#FFCB1F",
    fontWeight: "bold"
  },
  result: {
    alignSelf: "center",
    color: COLORS.accent,
    fontSize: 35,
    padding: 15
  },
  infoTxt: {
    alignSelf: "center",
    color: COLORS.primary,
    fontSize: 25,
    paddingTop: 15
  }
});